export const mergeArrays = (
  novasParcelasPedido: any[],
  finalizadorasPedido: any[],
): any[] => {
  if (finalizadorasPedido.length === 0) return novasParcelasPedido;

  const mergedArray = [...novasParcelasPedido, ...finalizadorasPedido];
  const uniqueArray = mergedArray.filter(
    (item, index, self) =>
      index ===
      self.findIndex(
        (t) =>
          t.cod_finalizadora === item.cod_finalizadora &&
          t.cod_condicao === item.cod_condicao &&
          t.num_condicao === item.num_condicao &&
          t.val_parcela === item.val_parcela &&
          t.dta_vencimento === item.dta_vencimento,
      ),
  );

  return uniqueArray;
};
